<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  data() {
    return {
      form: {
        active: true,
      },
      disableOnSubmit: false,
      dictionary: {
        en: {
          attributes: {
            my_notion_of_ten:
              "Define a 10/10 score then work your way down to 1/10",
            my_current_score: "My Current Score",
            my_aspirational_score: "My Aspirational Score",
            what_would_i_say_to_person: "What Would I say",
            actually_rating: "",
            how_do_i_deal_with_people:
              "How do I deal with people on the opposite end of this scale",
          },
        },
      },
      edited: false,
      editing: false,
      audio: false,
    };
  },

  props: ["url", "getUrl", "isEdit"],

  mixins: [validateAndSubmit, validationClass],

  computed: {
    actually_rating: function () {
      return this.form.actually_rating;
    },
    because: function () {
      return this.form.because;
    },
    evidence: function () {
      return this.form.evidence;
    },
    how_do_i_deal_with_people: function () {
      return this.form.how_do_i_deal_with_people;
    },
    how_much_does_it_apply_to_me: function () {
      return this.form.how_much_does_it_apply_to_me;
    },
    what_would_i_say_to_person: function () {
      return this.form.what_would_i_say_to_person;
    },
  },

  created() {},

  mounted() {
    this.getData();
    this.$validator.localize(this.dictionary);
    this.editing = this.isEdit == 1;
  },

  watch: {
    actually_rating: function (newValue, oldValue) {
      if (newValue && newValue == "0" && newValue !== oldValue) {
        this.displayWarningMessage("If No, then rethink your score!");
      } else {
        this.closeWarningMessage();
      }
      this.updateEdited(newValue, oldValue);
    },
    because: function (newValue, oldValue) {
      this.updateEdited(newValue, oldValue);
    },
    evidence: function (newValue, oldValue) {
      this.updateEdited(newValue, oldValue);
    },
    how_do_i_deal_with_people: function (newValue, oldValue) {
      this.updateEdited(newValue, oldValue);
    },
    how_much_does_it_apply_to_me: function (newValue, oldValue) {
      this.updateEdited(newValue, oldValue);
    },
    what_would_i_say_to_person: function (newValue, oldValue) {
      this.updateEdited(newValue, oldValue);
    },
  },

  methods: {
    getData() {
      axios
        .get(this.getUrl, {
          params: {},
        })
        .then((response) => {
          this.form = response.data.data;
          this.form.how_much_does_it_apply_to_me =
            this.form.how_much_does_it_apply_to_me != null
              ? this.form.how_much_does_it_apply_to_me
              : 0;

          this.form.how_do_i_deal_with_people =
            this.form.how_do_i_deal_with_people != null
              ? this.form.how_do_i_deal_with_people
              : "";

          var self = this;
          this.$nextTick(function () {
            self.edited = false;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    displayWarningMessage(message) {
      this.$root.$refs.toastr.defaultPosition = "toast-top-center";
      this.$root.$refs.toastr.defaultTimeout = 0;
      this.$root.$refs.toastr.w(message);
      this.$root.$refs.toastr.defaultPosition = "toast-top-right";
      this.$root.$refs.toastr.defaultTimeout = 5000;
    },
    closeWarningMessage() {
      this.$root.$refs.toastr.removeByType("warning");
    },
    submitForm() {
      this.edited = false;
      this.validateAndSubmit("traits-behaviors-and-attitudes-form");
    },
    next() {
      if (this.edited) {
        this.displayWarningMessage("You need to Save your answers!");
        return;
      }
      window.location.href = this.form.next_url;
    },
    previous() {
      if (this.edited) {
        this.displayWarningMessage("You need to Save your answers!");
        return;
      }
      window.location.href = this.form.previous_url;
    },
    updateEdited(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.edited = true;
      }
    },
  },

  components: {
    VueSlider,
  },
};
</script>
